import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CrmAuthProvider, useCrmAuth } from "./CrmAuth";
import CrmLayout from "./CrmLayout";
import CrmLogin from "./CrmLogin";
import Dashboard from "./Dashboard";
import { CustomersList, CustomerNew, CustomerDetail } from "./Customers";
import { VehiclesList, VehicleNew, VehicleDetail } from "./Vehicles";
import ServicesCatalog from "./Services";
import CheckIn from "./CheckIn";
import Calendar from "./Calendar";
import { WorkOrdersList, WorkOrderDetail } from "./WorkOrders";
import { EstimatesList, EstimateDetail, InvoicesList, InvoiceDetail } from "./Billing";
import Inventory from "./Inventory";
import Reports from "./Reports";
import Inspections from "./Inspections";
import InspectionDetail from "./InspectionDetail";
import PricingPage from "./PricingPage";
import BlogPage from "./BlogPage";
import FollowUps from "./FollowUps";
import Leads from "./Leads";
import QuickQuote from "./QuickQuote";
import SiteMedia from "./SiteMedia";
import ComingSoon from "./ComingSoon";

function Guard({ children }) {
  const { user, loading } = useCrmAuth();
  if (loading) return <div className="min-h-screen bg-[#08080b] flex items-center justify-center text-white/40 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/crm/login" replace />;
  return children;
}

export default function CrmApp() {
  return (
    <CrmAuthProvider>
      <Routes>
        <Route path="/login" element={<CrmLogin />} />
        <Route element={<Guard><CrmLayout /></Guard>}>
          <Route index element={<Dashboard />} />
          <Route path="quick-quote" element={<QuickQuote />} />
          <Route path="customers" element={<CustomersList />} />
          <Route path="customers/new" element={<CustomerNew />} />
          <Route path="customers/:id" element={<CustomerDetail />} />
          <Route path="follow-ups" element={<FollowUps />} />
          <Route path="leads" element={<Leads />} />
          <Route path="vehicles" element={<VehiclesList />} />
          <Route path="vehicles/new" element={<VehicleNew />} />
          <Route path="vehicles/:id" element={<VehicleDetail />} />
          <Route path="services" element={<ServicesCatalog />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="appointments" element={<Calendar />} />
          <Route path="appointments/new" element={<Calendar />} />
          <Route path="check-in" element={<CheckIn />} />
          <Route path="inspections" element={<Inspections />} />
          <Route path="inspections/:id" element={<InspectionDetail />} />
          <Route path="work-orders" element={<WorkOrdersList />} />
          <Route path="work-orders/:id" element={<WorkOrderDetail />} />
          <Route path="estimates" element={<EstimatesList />} />
          <Route path="estimates/:id" element={<EstimateDetail />} />
          <Route path="invoices" element={<InvoicesList />} />
          <Route path="invoices/:id" element={<InvoiceDetail />} />
          <Route path="payments" element={<ComingSoon title="Payments log" phase="1.3 · via Invoices" />} />
          <Route path="employees" element={<ComingSoon title="Employees" phase="2" />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="reports" element={<Reports />} />
          <Route path="pricing" element={<div className="p-4 md:p-8 max-w-6xl mx-auto"><PricingPage /></div>} />
          <Route path="blog" element={<div className="p-4 md:p-8 max-w-5xl mx-auto"><BlogPage /></div>} />
          <Route path="site-media" element={<SiteMedia />} />
          <Route path="settings" element={<ComingSoon title="Settings" phase="2" />} />
          <Route path="*" element={<Navigate to="/crm" replace />} />
        </Route>
      </Routes>
    </CrmAuthProvider>
  );
}
